import axios from 'axios';

// Lê textos e configurações editados no backoffice ("Textos Dinâmicos" e "Redes sociais").
// Devolve { chave: valor }; chaves sem conteúdo ficam de fora.
export const loadDynamicInfos = async (keys) => {
    const result = await axios.get('/api/dynamic-infos/keys', { params: { keys: keys.join(',') } });
    return (result.data.content || []).reduce(
        (values, item) => ({ ...values, [item.key]: item.value }),
        {}
    );
};
